export default "__VITE_ASSET__850d8317__"